<template>
  <div class="explain-phone fd-js-excludes" v-if="isMobile && isShowPhoneHelp">
    <div class="ex-phone fd-js-excludes">
      <div class="headerClose fd-js-excludes">
        <img src="@imgs/close2x.png" class="fd-js-excludes" alt="" @click="closeExplainPhone" />
      </div>
      <div class="ex-center fd-js-excludes">
        <div class="left fd-js-excludes">
          <img src="@imgs/SF2x.png" class="fd-js-excludes" alt="" />
          <p>双手缩放，查看细节</p>
        </div>
        <div class="right">
          <img src="@imgs/hd2x.png" class="fd-js-excludes" alt="" />
          <p>左右滑动，前后翻页</p>
        </div>
      </div>
      <div class="ex-three fd-js-excludes">
        <button @click="closeExplainPhone" class="fd-js-excludes">我已了解</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ExplainPhone',
  data() {
    return {
      visible: true
    }
  },
  computed: {
    isMobile() {
      return this.$store.state.book.isMobile
    },
    isShowPhoneHelp() {
      return this.$store.state.book.isShowPhoneHelp
    }
  },
  methods: {
    closeExplainPhone() {
      // $('.explain-phone').hide()
      this.$store.commit('book/UPDATE_IS_SHOW_PHONE_Help', false)
    }
  }
}
</script>

<style lang="scss" scoped>
.explain-phone {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 20000;
  .ex-phone {
    width: 300px;
    height: 300px;
    background: rgba(0, 0, 0, 0.85);
    border-radius: 10px;
    .headerClose {
      width: 100%;
      height: 28px;
      position: relative;
      img {
        width: 26px;
        height: 26px;
        position: absolute;
        top: 2px;
        right: 2px;
      }
    }
    .ex-center {
      width: 242px;
      height: 110px;
      margin: 10px auto 79px;
      display: flex;
      .left,
      .right {
        width: 108px;
        height: 100%;
        img {
          width: 84px;
          height: 100px;
          margin-left: 6px;
        }
        p {
          width: 108px;
          font-size: 14px;
          color: #fff;
        }
      }
      .right {
        margin-left: 40px;
      }
    }
    .ex-three {
      width: 100%;
      height: 32px;
      display: flex;
      justify-content: center;
      align-items: center;
      button {
        width: 100px;
        height: 30px;
        text-align: center;
        line-height: 30px;
        color: #000;
        border-radius: 5px;
        border: 0;
        outline: none;
        font-size: 14px;
        background: #fff;
      }
    }
  }
}
</style>
